import React from "react";
import { Alert } from "@mui/material";
import { useCompanyRole } from "../servicos/useCompanyRole";

/**
 * Shown to assurers (backlog A-01): external reviewers with read-only
 * access. Writes are refused by the API; this explains why up front.
 */
export const AssurerBanner: React.FC = () => {
	const role = useCompanyRole();
	if (role !== "assurer") return null;
	return (
		<Alert severity="info" sx={{ mb: 2 }}>
			<strong>Assurance view</strong> — you have read-only access to this
			company: review the dashboard, reports, evidence and audit trail.
			Data can't be changed from this account.
		</Alert>
	);
};
